import React, { useState, useEffect } from 'react';
import helmetLogoImg from '../../assets/images/usmlcascoblancochico.png';

/**
 * GlobalHeader - Layout Component
 *
 * Main navigation header with USML logo and menu
 * Responsive mobile menu, scroll behavior, Tactical Precision styling
 */
export const GlobalHeader = ({ navLinks = [], className = '', ...props }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  // Default nav links if none provided
  const defaultNavLinks = [
    { id: 'home', label: 'Inicio' },
    { id: 'about', label: 'Nosotros' },
    { id: 'branches', label: 'Ramas' },
    { id: 'gallery', label: 'Galería' },
    { id: 'members', label: 'Miembros' },
    { id: 'contact', label: 'Unirse' }
  ];

  const links = navLinks.length > 0 ? navLinks : defaultNavLinks;

  return (
    <nav
      className={`navbar ${scrolled ? 'scrolled' : ''} ${className}`.trim()}
      {...props}
    >
      <div className="navbar-container">
        <a
          href="#home"
          className="logo"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection('home');
          }}
        >
          <img src={helmetLogoImg} alt="USML Helmet" className="logo-helmet" />
          <span>USML</span>
        </a>

        <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          {links.map((link, index) => (
            <li key={link.id}>
              <a
                href={`#${link.id}`}
                className={index === links.length - 1 ? 'nav-cta' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(link.id);
                }}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          className="mobile-menu-toggle"
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          ☰
        </button>
      </div>
    </nav>
  );
};

export default GlobalHeader;
